import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['destination', 'template']
  static values = {
    ifDifferent: String,
    action: {
      type: String,
      default: "append"
    },
    onlyOnce: {
      type: Boolean,
      default: false
    }
  }

  inject() {
    if (this.onlyOnceValue && this.destinationTarget.querySelector('[data-injected-html]')) {
      return
    }

    if (this.actionValue == "append") {
      this.destinationTarget.insertAdjacentHTML('beforeend', this.templateTarget.innerHTML)
      this.destinationTarget.firstElementChild.dataset.injectedHtml = true
    } else if (this.actionValue == "replace") {
      this.destinationTarget.innerHTML = this.templateTarget.innerHTML
    }
  }

  injectIfDifferent(e) {
    if (this.ifDifferentValue != e.target.value) {
      this.inject()
    }
  }

  remove(e) {
    e.target.closest('[data-anchor]').remove()
  }

  removeIfSame(e) {
    if (this.ifDifferentValue == e.target.value) {
      this.destinationTarget.querySelector('[data-injected-html]').remove()
    }
  }
}
